import {SigmaContainer, SigmaContainerProps} from '@react-sigma/core';
import {UndirectedGraph} from 'graphology';
import React from 'react';
import EdgeProgram from "sigma/rendering/webgl/programs/edge";
import NodeProgram from "sigma/rendering/webgl/programs/node";
import SigmaReadyController from "../components/SigmaReadyController";
import {AppSettings} from '../settings';


// Allow passing SigmaContainer props for graph, settings, style, and className
export type SigmaProviderProps = Pick<
  SigmaContainerProps,
  'graph' | 'settings' | 'style' | 'className'
> & {
  children: React.ReactNode;
};

export const SigmaProvider: React.FC<SigmaProviderProps> = (
  {
    graph = UndirectedGraph,
    settings = {
      hideEdgesOnMove: true,
      hideLabelsOnMove: true,

      nodeProgramClasses: {NodeProgram},
      edgeProgramClasses: {EdgeProgram},

      zIndex: true,
      defaultNodeColor: AppSettings.NODE_COLOUR,
      defaultEdgeColor: AppSettings.EDGE_COLOUR,

      stagePadding: 50,
    },
    style = {backgroundColor: AppSettings.BACKGROUND_COLOUR},
    className = "",
    children,
  }) => {
  return <SigmaContainer graph={graph} settings={settings} style={style} className={className}>
    <SigmaReadyController/>
    {children}
  </SigmaContainer>;
}

export default SigmaProvider;
